/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react'

import ProductWithIntersectionalBannersLayout from './ProductWithIntersectionalBannersLayout'
import ProductWithIntersectionalBannersLogic from './ProductWithIntersectionalBannersLogic'

const ProductWithIntersectionalBanners = (props: any) => {
  return (
    <ProductWithIntersectionalBannersLogic
      {...props}
      Wrapper={ProductWithIntersectionalBannersLayout}
    />
  )
}

export default memo(ProductWithIntersectionalBanners)
